import global from "@/prototype/global.js";

import {make_ids_unique} from "svg-utils";

const d3 = global.d3;

const log = global.log.getLogger("f_mtac.scene.geonodes.geonode");
log.setLevel(log.levels.WARN);

const placeholder_name = type => (type === "A") ? "pivot_a" : "pivot_b";
const placeholder_node = type => global.resources.category["_placeholder"][placeholder_name(type)];

const Geonode = function(geonodes, group, type) {
    const geonode = placeholder_node(type).cloneNode(true);
    make_ids_unique(global.svg.root.node(), geonode);
    geonode.removeAttribute("transform");
    this.group = group;
    this.geonode = geonode;
    this.handle = d3.create("svg:g").attr("class", "handle");
    this.node = this.handle.append("g").attr("class", "geonode node movable removable");
    this.node.attr("data-geonode-name", type);
    this.color = this.node.append("g").attr("class", "color");
    this.color.append("circle")
        .attr("class", "color")
        .attr("cx", 100)
        .attr("cy", 100)
        .attr("r", 87)
        .attr("fill", "#fff");
    this.figure = this.node.append("g").attr("class", "figure");
    this.figure.append(() => this.geonode).attr("transform", null);
    this.position = {x: 0, y: 0};
    this.coordinates = {E: undefined, N: undefined};
    this.type = type;
    this.remove = () => {
        log.debug("Geonode.remove");
        geonodes.remove(type);
        geonodes.apply();
        geonodes = undefined;
    };
    this.apply = () => {
        log.debug("Geonode.apply");
        geonodes.apply();
    };
    this.set_coordinates = ({E, N}) => {
        this.coordinates.E = E;
        this.coordinates.N = N;
        geonodes.apply();
    };
};
const apply_transform = (geonode) => {
    var {x, y} = geonode.position;
    geonode.node.attr("transform", `translate(${x - 100},${y - 100})`);
};
Geonode.prototype.draw = function({x, y, E, N}) {
    this.position.x = x;
    this.position.y = y;
    this.coordinates.E = E;
    this.coordinates.N = N;
    apply_transform(this);
    this.group.node().appendChild(this.handle.node());
};
/*
Geonode.prototype.replace = function(geonode) {
    this.figure.html("");
    this.figure.append(() => geonode).attr("transform", null);
    this.geonode = geonode;
};
*/
Geonode.prototype.move = function({x, y}) {
    this.position.x += x;
    this.position.y += y;
    apply_transform(this);
};
Geonode.prototype.move_to = function({x, y}) {
    this.position.x = x;
    this.position.y = y;
    apply_transform(this);
};
export default Geonode;
